// Migration: v8 → v9
// Checkbox/radio noteSettings gain type/options/nested noteSettings. Backfill
// only those new fields so stored JSON matches the new shape (no reliance on
// Zod defaults for legacy data). required/width already existed in v8.

import type { MigratableTemplateContent } from './types';

const NOTE_HOST_TYPES = new Set(['radio', 'checkbox']);

const backfillNoteSetting = (raw: unknown): unknown => {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return raw;
  }

  const setting = { ...(raw as Record<string, unknown>) };

  if (typeof setting.type !== 'string') {
    setting.type = 'inputText';
  }
  if (!Array.isArray(setting.options)) {
    setting.options = [];
  }
  if (!Array.isArray(setting.noteSettings)) {
    setting.noteSettings = [];
  }
  return setting;
};

const backfillHostWidgetNoteSettings = (
  widget: Record<string, unknown>,
): void => {
  const type = widget.type;
  if (typeof type !== 'string' || !NOTE_HOST_TYPES.has(type)) return;

  const noteSettings = widget.noteSettings;
  widget.noteSettings = Array.isArray(noteSettings)
    ? noteSettings.map(backfillNoteSetting)
    : [];
};

export const migrateV8ToV9 = (data: MigratableTemplateContent): void => {
  for (const rawWidget of Object.values(data.widgets)) {
    backfillHostWidgetNoteSettings(rawWidget as Record<string, unknown>);
  }
  data.version = '9';
};
